import { navigate } from '@reach/router';
import { projectUrls } from '../../projects/projectUrls';
import { NextStepAfterSavingQuote } from './QuoteForm';

export const navigateAfterSavingQuote = (
  projectId: number,
  quoteId: number,
  isDraft: boolean,
  nextStepAfterSave: NextStepAfterSavingQuote,
  onGenerateBillOfMaterials: (quoteId: number) => void,
) => {
  if (isDraft) {
    return navigate(projectUrls.editQuote(projectId, quoteId));
  }

  if (nextStepAfterSave === 'GenerateBillOfMaterials') {
    return onGenerateBillOfMaterials(quoteId);
  }

  return navigate(projectUrls.projectDetails(projectId));
};
